import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../api-response';
import { BaseApiService } from '../../../core/base-api.service';
import { StopContent } from '../../../shared/models/stop-content.model';

/** Last published content-delivery payload for a single stop —
 *  /api/v1/admin/content-delivery/tenants/{tenantId}/feeds/{feedId}/stops/{stopId}.
 *  404 means nothing has been published for the stop yet, not an error;
 *  callers should treat it the same way FeedService.getDiagnostics does. */
@Injectable({ providedIn: 'root' })
export class ContentDeliveryService extends BaseApiService {
  private readonly http = inject(HttpClient);

  stopContentUrl(tenantId: string, feedId: string, stopId: string): string {
    return `${this.coreApiUrl}/api/v1/admin/content-delivery/tenants/${tenantId}/feeds/${feedId}/stops/${stopId}`;
  }

  getStopContent(tenantId: string, feedId: string, stopId: string): Observable<ApiResponse<StopContent>> {
    return this.http.get<ApiResponse<StopContent>>(this.stopContentUrl(tenantId, feedId, stopId));
  }
}
